@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.batch-note-wrapper {
  display: flex;
  align-items: center;
}

.note-input {
  margin-left: 5px;
  min-height: 40px;
  height: 40px;
  display: flex;

  .edit-text-area {
    resize: none;
    width: 100%;
    transition: all 300ms ease;
    min-height: 40px;
    height: auto;
    font-size: 14px;
  }
}

.note {
  display: flex;
  align-items: center;
  margin-left: 5px;
  border-bottom: none;
  box-shadow: none;
  background-color: @batches--note--background-color;
  overflow: auto;
  padding: 2px 6px;

  &:hover {
    background: @batches--note--hover--background-color;
    box-shadow: none;
  }
}

.batch-note-label {
  margin-left: 5px;
}

.note-content {
  font-size: 13px;
  text-align: left;
}
